import React from 'react';
import { IconProps } from '.';

const SvgTruckReturn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M3 4.75h4a2.25 2.25 0 0 1 0 4.5H3.685L5.51 7.549 4.49 6.45.939 9.758l3.513 3.755 1.096-1.025-1.626-1.738H7a3.75 3.75 0 1 0 0-7.5H3v1.5Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M13 5.75h1.25v10.5h-2.813A2.996 2.996 0 0 0 9 15a2.996 2.996 0 0 0-2.437 1.25H3.75V15h-1.5v2.75h3.76a3 3 0 1 0 5.98 0h3.02a3 3 0 1 0 5.98 0h2.76v-5.576L20.675 9.25H15.75v-5H13v1.5Zm2.75 5v5.266A2.993 2.993 0 0 1 18 15c1.004 0 1.892.493 2.437 1.25h1.813v-3.433l-2.175-2.067H15.75ZM10.5 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTruckReturn;
